import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  USER_PROFILE_VIEW_LIST_START: "USER_PROFILE_VIEW_LIST_START",
  USER_PROFILE_VIEW_SUCCESS: "USER_PROFILE_VIEW_SUCCESS",
  USER_PROFILE_VIEW_FAILED: "USER_PROFILE_VIEW_FAILED"
};

// ============================================ Actions ========================================================

export const userProfileViewListStart = data => ({
  type: actionType.USER_PROFILE_VIEW_LIST_START,
  payload: data
});

export const userProfileViewSuccess = data => ({
  type: actionType.USER_PROFILE_VIEW_SUCCESS,
  payload: data
});

export const userProfileViewFailed = data => ({
  type: actionType.USER_PROFILE_VIEW_FAILED,
  payload: data
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null
};

export default function userProfileViewListReducer(state = INIT_STATE, action) {
  switch (action.type) {    
    case actionType.USER_PROFILE_VIEW_LIST_START:
      return {
        ...state,
        loading: true
      };

    case actionType.USER_PROFILE_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case actionType.USER_PROFILE_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================
export function* userProfileViewListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
        const userProfileView = response?.data?.data?.allUserprofileviews;
      yield put(
        userProfileViewSuccess(userProfileView)
      );
    } else {
      messagePopup("", "User profile View Api failed", "error");
      yield put(userProfileViewFailed("User profile View Api failed"));
    }
  } catch (error) {
    messagePopup("", "User profile View Api failed", "error");
    yield put(userProfileViewFailed("User profile View Api failed"));
  }
}

export function* watchUserProfileViewListSaga() {
  yield takeEvery(actionType.USER_PROFILE_VIEW_LIST_START, userProfileViewListSaga);
}